import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import {
  Grid,
  Button,
  FormControl,
  TextField,
  FormControlLabel,
  Checkbox,
  Chip,
} from '@mui/material';
import { Cancel, Save, Done } from '@mui/icons-material/';
import { AnchorPopup } from 'shared/components';
import { saveFilters } from '../../actions/filters';

const useStyles = makeStyles(() => ({
  form: {
    width: '100%',
  },
  select: {
    display: 'block',
    width: '100%',
  },
  rootBottom: {
    flexGrow: 1,
    marginTop: 10,
    marginBottom: 10,
    textAlign: 'center',
  },
  button: {
    fontSize: 12,
  },
  chip: {
    width: '100%',
    marginTop: 10,
    marginBottom: 10,
  },
}));

const SaveFilterPopup = props => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [primary, setPrimary] = React.useState(false);
  const [name, setName] = React.useState('');
  const [filterSaved, setFilterSaved] = React.useState(false);
  const { selectedFilters } = useSelector(state => state.filters);

  const handleChange = () => {
    setPrimary(!primary);
  };

  const handleChangeName = event => {
    setName(event.target.value);
  };

  const handleSave = async () => {
    await dispatch(
      saveFilters({
        data: {
          type: 'dashboard_templates',
          attributes: {
            primary,
            name,
            template: selectedFilters,
          },
        },
      }),
    );
    setName('');
    setPrimary(false);
    setFilterSaved(true);
  };

  const isSaveEnabled = () => {
    const selected = Object.keys(selectedFilters).reduce((total, key) => {
      total += selectedFilters[key].length;
      return total;
    }, 0);
    return name !== '' && selected > 0;
  };

  const handleFilterSaved = () => {
    setFilterSaved(false);
  };

  return (
    <AnchorPopup {...props}>
      <FormControl className={classes.form}>
        <TextField
          label="Filter Set name:"
          value={name}
          onChange={handleChangeName}
        />
      </FormControl>
      <FormControlLabel
        control={
          <Checkbox checked={primary} onChange={handleChange} color="primary" />
        }
        label="Denote as Primary Set?"
      />
      <div className={classes.rootBottom}>
        <Grid container direction="row" justify="center" alignItems="center">
          <Grid item xs={4}>
            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              startIcon={<Save />}
              onClick={handleSave}
              disabled={!isSaveEnabled()}
            >
              Save
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button
              className={classes.button}
              variant="contained"
              color="inherit"
              startIcon={<Cancel />}
              onClick={props.onClose}
            >
              Close
            </Button>
          </Grid>
        </Grid>
      </div>
      {filterSaved && (
        <Chip
          className={classes.chip}
          color="primary"
          label="FILTER SAVED"
          onClick={handleFilterSaved}
          onDelete={handleFilterSaved}
          deleteIcon={<Done />}
        />
      )}
    </AnchorPopup>
  );
};

SaveFilterPopup.propTypes = {
  onClose: PropTypes.func,
};

export default SaveFilterPopup;
